"use strict";
(function () {
  if (!customElements.get("product-sku")) {
    class ProductSKU extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.hasInitialized = false; // <── guard
        this.hasMoved = false; // <── guard
      }

      connectedCallback() {
        // Prevent re-init when the element is moved in the DOM
        if (this.hasInitialized) return;

        this.hasInitialized = true;
        this.init();
      }

      disconnectedCallback() {
        this.disconnectObserver();
      }
    }

    /* ========== Prototype Methods ========== */

    ProductSKU.prototype.init = function () {
      const target = document.getElementById("etrusted-product_star");
      if (!target) return;

      this.observeTarget(target);
    };

    ProductSKU.prototype.observeTarget = function (target) {
      // Check immediately
      this.checkAndMove(target);

      if (this.hasMoved) return;

      this.observer = new MutationObserver(() => {
        this.checkAndMove(target);
      });

      this.observer.observe(target, {
        childList: true,
        subtree: true,
      });
    };

    ProductSKU.prototype.disconnectObserver = function () {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    };

    ProductSKU.prototype.checkAndMove = function (target) {
      if (this.hasMoved) return;

      const widget = target.querySelector("etrusted-widget");
      if (!widget) return;

      // Move element
      widget.insertAdjacentElement("afterend", this);

      // Mark as done
      this.hasMoved = true;

      // Stop observing
      this.disconnectObserver();
    };

    customElements.define("product-sku", ProductSKU);
  }
})();
